import {BASE_URL} from '../config'

const globalStyles = (theme) => (
    {
        '@global': {
            '@import': 'url(https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css)',
            '@font-face': [{
                fontFamily: 'ProximaNova',
                src: "url('" + BASE_URL + "/fonts/proximanova-light-webfont.woff2') format('woff2'), url('/fonts/proximanova-light-webfont.woff') format('woff')",
                fontWeight: 200,
                fontStyle: "normal"
            },
            {
                fontFamily: 'ProximaNova',
                src: "url('" + BASE_URL + "/fonts/proximanova-regular-webfont.woff2') format('woff2'), url('/fonts/proximanova-regular-webfont.woff') format('woff')",
                fontWeight: "normal",
                fontStyle: "normal"
            },
            {
                fontFamily: 'ProximaNovaBold',
                src: "url('" + BASE_URL + "/fonts/proximanova-bold-webfont.woff2') format('woff2'), url('/fonts/proximanova-bold-webfont.woff') format('woff')",
                fontWeight: "bold",
                fontStyle: "normal"
            },
            {
                fontFamily: 'ProximaNovaExCond',
                src: "url('" + BASE_URL + "/fonts/proximanovaexcn-light-webfont.woff2') format('woff2'), url('/fonts/proximanovaexcn-light-webfont.woff') format('woff')",
                fontWeight: "normal",
                fontStyle: "normal"
            },
            {
                fontFamily: 'ProximaNovaExCond',
                src: "url('" + BASE_URL + "/fonts/proximanovaexcn-light-webfont.woff2') format('woff2'), url('/fonts/proximanovaexcn-light-webfont.woff') format('woff')",
                fontWeight: "normal",
                fontStyle: "normal"
            },
            {
                fontFamily: 'Didot',
                src: "url('" + BASE_URL + "/fonts/DidotLTPro-Roman.woff2') format('woff2'),url('/fonts/DidotLTPro-Roman.woff') format('woff')",
                fontWeight: "normal",
                fontStyle: "normal"
            },
            {
                fontFamily: 'Didot',
                src: "url('" + BASE_URL + "/fonts/DidotLTStd-Italic.woff2') format('woff2'),url('/fonts/DidotLTStd-Italic.woff') format('woff')",
                fontWeight: "normal",
                fontStyle: "italic"
            }],
            html: {
                boxSizing: "border-box",
                fontSize: theme.base.fontSize,
                '-webkit-font-smoothing': 'antialiased',
                lineHeight: theme.base.lineHeight,
                height: "100%",
            },
            "*, *::before, *::after": {
                boxSizing: "inherit"
            },
            body: {
                height: "100%",
                minHeight: "100vh",
                margin: 0,
                padding: 0,
                color: theme.colors.black,
                fontFamily: theme.font.family,
                fontSize: theme.base.fontSize,
                fontWeight: 200,
                lineHeight: theme.base.lineHeight,
                minWidth: "100%"
            },
            '.smallVerticalFlow': {
                ...theme.spacing.smallMarginBottom
            },
            ".normalVerticalFlow, p,h1,h2,h3,h4,h5,h6,ul,ol,dd,pre,table,hr": {
                ...theme.spacing.normalMarginBottom
            },
            '.largeVerticalFlow': {
                ...theme.spacing.largeMarginBottom
            },
            "nav > ul": {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            ".sr-only": {
                position: "absolute !important",
                width: 1,
                height: 1,
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)"
            },
            "p, h1, h2, h3, h4, h5, h6,section,aside": {
                margin: 0
            },
            "p": {
                ...theme.font.p,
            },
            "li": {
                ...theme.font.li,
            },
            "li, p, a": {
                "& b,strong": {
                    fontWeight: "bold"
                },
            },
            "h1": {
                textTransform: "uppercase",
                ...theme.font.title.h1
            },
            "h2": {
                ...theme.font.title.h2
            },
            "h3": {
                textTransform: "uppercase",
                ...theme.font.title.h3
            },
            "h4, h5, h6": {
                textTransform: "uppercase",
                ...theme.font.title.h4
            },
            "a": {
                color: theme.link.color,
                transition: "color 0.2s",
                cursor: 'pointer',
                textDecoration: 'none',
                "&:hover": {
                    color: theme.link.hover.color,
                    textDecoration: 'underline'
                },
            },
            "q": { quotes: "'\\201c' '\\201d'" },
            "q:before": { content: "open-quote" },
            "q:after": { content: "close-quote" },
            "section": {
                marginBottom: theme.spacing.large,
                "&:after": {
                    clear: "both",
                    content: '""',
                    display: "table"
                },
                [theme.breakpoint('tablet')]: {
                    marginBottom: theme.spacing.huge
                }
            },
            '.coverAbsolute': {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            '.row': {
                margin: '0 auto',
                maxWidth: theme.content.widthLarge,
                width: '100%'
            },
            'p.center-align': {
                textAlign: 'center',
                marginBottom: 0
            },
            'p.right-align': {
                textAlign: 'right',
                marginBottom: 0
            }
        }
    }
)

export default globalStyles;


// WEBPACK FOOTER //
// ./src/styles/global.js